import { useStytchMember } from '@stytch/react/b2b'
import useSessionStorageUIDotDev from './useSessionStorageUIDotDev'

export default function useSessionStorage<T>(key: string, initialValue: T) {
  const { member } = useStytchMember()
  // @ts-expect-error -- external_id exists in member object
  const fullKey = `${key}-${member?.external_id || 'logged-out'}`

  return useSessionStorageUIDotDev(fullKey, initialValue)
}
